import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter041() {
  return <KbChapterPage slug="chapter-041" />;
}

(Chapter041 as unknown as { path: string }).path = "/theory-album/041";
